import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ModalRef } from "@odx/angular/components/modal";

@Component({
  selector: "app-reference-measure-confirm-modal",
  imports: [UiKitModule],
  templateUrl: "./reference-measure-confirm-modal.component.html",
  styleUrl: "./reference-measure-confirm-modal.component.scss",
})
export class ReferenceMeasureConfirmModalComponent {
  public readonly modalRef = inject(ModalRef);

  onDismiss() {
    this.modalRef.close(false);
  }

  onConfirm() {
    this.modalRef.close(true);
  }
}
